import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { SpinnerComponent } from '../spinner/spinner.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, SpinnerComponent, MatButton, MatIcon, TranslatePipe],
})
export class HeaderMenuComponent {
  readonly menuList = input<
    {
      label: string;
      link: string;
    }[]
  >([]);
  readonly logoutEvent = output();

  onLogout() {
    this.logoutEvent.emit();
  }
}
